// extracted by mini-css-extract-plugin
export default {"productCarousel":"e1-z"};